module.exports = __webpack_public_path__ + "img/3-2.4045d580.png";